import { PERMISSION_SUBJECTS } from './permissionSubjects';
import { IScmToolsCardData } from 'types/IScmToolsCardData';
import assetUploadToolIcon from 'assets/icons/assetUploadTool.svg';
import classroomCreationToolIcon from 'assets/icons/classroomCreationTool.svg';
import communicationManagementToolIcon from 'assets/icons/snoozingBell.svg';
import courseResumeToolIcon from 'assets/icons/courseResumeTool.svg';
import gearIcon from 'assets/icons/gearIcon.svg';
import neovarsityManagementTool from 'assets/icons/neovarsityManagementTool.svg';
import recordingsToolIcon from 'assets/icons/RecordingsTool.svg';
import satManagementToolIcon from 'assets/icons/satManagementTool.svg';

export const SCM_TOOLS_CARD_DATA: IScmToolsCardData[] = [
  {
    title: 'Classroom Creation Tool',
    icon: classroomCreationToolIcon,
    to: '/classes/view-schedule',
    subjects: [
      PERMISSION_SUBJECTS.academyTopic,
      PERMISSION_SUBJECTS.library,
      PERMISSION_SUBJECTS.playlist,
      PERMISSION_SUBJECTS.sbatGroup,
      PERMISSION_SUBJECTS.superBatch,
    ],
  },
  {
    title: 'Course Resume Tool',
    icon: courseResumeToolIcon,
    to: '/course-pause',
    subjects: [PERMISSION_SUBJECTS.coursePauseRequest],
  },
  {
    title: 'SAT Management Tool',
    icon: satManagementToolIcon,
    to: '/sat-management/reset-sat',
    subjects: [PERMISSION_SUBJECTS.courseAssessmentMentee],
  },
  {
    title: 'Recording Request Tool',
    icon: recordingsToolIcon,
    to: '/recordings/view-pending-requests',
    subjects: [PERMISSION_SUBJECTS.recordingRequest],
  },
  {
    title: 'Asset Management Tool',
    icon: assetUploadToolIcon,
    to: '/asset-management',
    subjects: [PERMISSION_SUBJECTS.rawAsset],
  },
  {
    title: 'Module Management Tool',
    icon: gearIcon,
    to: '/module-management',
    subjects: [PERMISSION_SUBJECTS.menteeModule],
  },
  {
    title: 'Communication Management Tool',
    icon: communicationManagementToolIcon,
    to: '/communication-management',
    subjects: [PERMISSION_SUBJECTS.blacklist],
  },
  {
    title: 'Credit Management Tool',
    icon: gearIcon,
    to: '/credit-management',
    subjects: [PERMISSION_SUBJECTS.userCredit],
  },
  {
    title: 'Neovarsity Management Tool',
    icon: neovarsityManagementTool,
    to: '/neovarsity',
    subjects: [PERMISSION_SUBJECTS.capstoneSubmission],
  },
  {
    title: 'Super Batch Management Tool',
    icon: gearIcon,
    to: '/super-batch-management',
    subjects: [PERMISSION_SUBJECTS.sbatGroup, PERMISSION_SUBJECTS.superBatch],
  },
];
